import React from 'react'
import { Notification } from '@local/do-secundo-notification'
import { Cart } from '../../../types/cart'
import { t } from '@local/translations'
import { useDate } from '../../../hooks/useDate'
import { InfoIcon } from '@toasttab/buffet-pui-icons'

export interface LeadTimeValidationProps {
  cart: Cart
}

const WARNING_THRESHOLD_MINUTES = 30

export const LeadTimeValidation: React.FC<LeadTimeValidationProps> = ({
  cart
}) => {
  const { toRelativeDateString, toFormatedHours } = useDate()
  const orderCutoffTime = cart.orderCutoffTime

  if (!orderCutoffTime || !cart.fulfillmentDateTime) {
    return null
  }

  const now = new Date()
  const cutoff = new Date(orderCutoffTime)
  const minutesRemaining = Math.floor(
    (cutoff.getTime() - now.getTime()) / (1000 * 60)
  )

  if (minutesRemaining <= WARNING_THRESHOLD_MINUTES) {
    const timeStr = toFormatedHours(orderCutoffTime, false)
    return (
      <Notification severity='warning' isActionable={false}>
        <div className='flex gap-2 items-start'>
          <InfoIcon accessibility='decorative' />
          <span>
            {t('lead-time-validation.warning-heading')}
            <br />
            {t('lead-time-validation.warning-cutoff', { time: timeStr })}
          </span>
        </div>
      </Notification>
    )
  }

  const dateStr = toRelativeDateString(orderCutoffTime)
  const timeStr = toFormatedHours(orderCutoffTime, false)
  return (
    <Notification severity='neutral' isActionable={false}>
      {t('lead-time-validation.neutral-message', {
        date: dateStr,
        time: timeStr
      })}
    </Notification>
  )
}

LeadTimeValidation.displayName = 'LeadTimeValidation'
